/* eslint-disable import/order */
/* eslint-disable react/jsx-no-bind */
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// Redux
const { bindActionCreators } = require('redux');

// i18n
const translate = require('../../../../../translation');

// Andes components
const { Message } = require('@andes/message');
const { CardFooter } = require('@andes/card');

// Cow components
const PaymentMethodCardList = require('@cow/core-components/components/PaymentMethodCardList');

// Custom Components
const ReviewBase = require('../index');
const ConsumerCredits = require('../../components/ConsumerCredits');

// Custom hooks
const { useActions } = require('../../hooks/useActions');
const { usePaymentCardList } = require('../../hooks/usePaymentCardList');
const useExpress = require('../../hooks/useExpress');
const usePaymentMethodDiscountWatcher = require('../../hooks/usePaymentMethodDiscountWatcher');

// Actions
const STEP_ACTIONS = require('../../../../../spa/actions/step');
const REQUEST_ACTIONS = require('../../../../../spa/actions/request');
const LOADING_ACTIONS = require('../../../../../spa/actions/loading');
const EXPRESS_ACTIONS = require('../../../../../spa/actions/express');
const captchaToken = require('../../../../../spa/actions/captchaToken');


// Utils
const PCJ = require('../../../../../utils/pcj');
const {
  genericPropsTypes,
  genericDefaultValues,
  newInterfaceGenericPropsTypes,
  newInterfaceGenericDefaultValues,
} = require('../../../../../utils/propTypes');
const connectToReduxAndInjectI18n = require('../../../../../utils/connectToRedux');
const withSmartTokenizationProvider = require('../../../../../components/HOCs/withSmartTokenization');

// Constants
const {
  METRICS: { ACTION_REVIEW_METRICS },
  SELECTORS: { ANDES_BUTTON_PAY_DESKTOP },
  APP: {
    ERROR_SPA: { BROWSER_INFO_ERROR },
    SUMMARY_ITEMS_TYPES: { COUPON_DISCOUNT },
    SECURE_FIELDS: {
      ERROR_CAUSES: { INVALID_VALUE },
    },
  },
  COMMONS: {
    ICONS_METHODS,
    DEVICE_TYPE: { DESKTOP },
    CHECKOUT_CASE: { EXPRESS },
    PAYMENT_METHOD_ID: { CONSUMER_CREDITS, SPLIT_CARDS },
    PAYMENT_METHOD: { CREDIT_CARD, DEBIT_CARD, PREPAID_CARD },
  },
} = require('../../../../../../constants');
const { useSmartTokenizationContext } = require('../../../../../components/SmartTokenizationProvider');
const { usePaymentMethod } = require('../../hooks/usePaymentMethod');

const ReviewExpress = (originalProps) => {
  const translations = translate(originalProps.i18n);
  const { paymentMethod, setPaymentMethod } = usePaymentMethod({
    paymentMethods: originalProps.step_model.payment_methods,
  });

  const [browserInfo, setBrowserInfo] = React.useState({});
  const [cardToken, setCardToken] = React.useState('');
  const [nextDueDate, setNextDueDate] = React.useState(null);
  const [showKycModal, setShowKycModal] = React.useState(false);
  const [showConsumerCreditsInfos, setShowConsumerCreditsInfos] = React.useState(false);

  const props = {
    ...PCJ.ifCandidateInjectPropsIntoSummary({
      translations,
      props: originalProps,
      paymentMethod,
    }),
  };

  const {
    sdk,
    flow,
    siteId,
    history,
    express,
    stepActions,
    captchaToken,
    captchaConfig,
    expressActions,
    requestActions,
    loadingActions,
    internalDeviceId,
    rebrandingMP,
    step_model,
  } = props;

  const { payer, captcha, challenge_instructions: challengesInstructions, transaction_type } = step_model;

  const withCombination = step_model?.combinations?.show_combination_row;

  const hasCCAPTokenizationFlagEnabled = props?.ccapTokenizationFlagEnabled;

  const { paymentCardList, shouldRenderInstallments, shouldRenderSecurityCode, paymentMethods, setPaymentMethods } = usePaymentCardList({
    express,
    translations,
    paymentMethods: step_model.payment_methods,
    rebrandingMP,
    hasCCAPTokenizationFlagEnabled,
    discount: paymentMethod?.discount,
    withCombination,
    selectedMethod: paymentMethod,
    deviceType: DESKTOP,
  });

  const {
    reviewExpressPay,
    reviewExpressKyC,
    changePaymentMethod,
  } = useActions({
    flow,
    payer,
    captcha,
    history,
    stepActions,
    captchaToken,
    captchaConfig,
    requestActions,
    loadingActions,
    challengesInstructions,
  });

  const smartTokenizationContext = useSmartTokenizationContext();

  const {
    showBankInterests,
    getCustomSummaryItems,
    handlePaymentMethodChange,
    handleChangePaymentMethod,
    handleKyc,
    handlePayClick,
    handlePaymentMethodFields,
    getCustomPrice,
    isCombination,
  } = useExpress({
    props,
    deviceType: DESKTOP,
    translations,
    sdk,
    siteId,
    express,
    expressActions,
    loadingActions,
    internalDeviceId,
    paymentMethod,
    setPaymentMethod,
    paymentMethods,
    setPaymentMethods,
    cardToken,
    setCardToken,
    browserInfo,
    setBrowserInfo,
    setNextDueDate,
    showKycModal,
    setShowKycModal,
    setShowConsumerCreditsInfos,
    shouldRenderInstallments,
    shouldRenderSecurityCode,
    hasCCAPTokenizationFlagEnabled,
    smartTokenizationContext,
    transaction_type,
    payer,
    challengesInstructions,
    changePaymentMethod,
    reviewExpressPay,
    reviewExpressKyC,
    step_model,
  });

  const getBottomContentListClass = () => {
    const lastPaymentMethod = paymentCardList[paymentCardList.length - 1];
    return classNames('review-express__change-payment-method', {
      'review-express__change-payment-method--single': !lastPaymentMethod.collapsedContent,
    });
  };

  const getCustomDiscountLegalTerms = () => paymentMethod?.discount?.legal_terms;

  usePaymentMethodDiscountWatcher({
    paymentMethods,
    callback: handlePaymentMethodFields,
    pathsToWatch: ['discount']
  });

  return (
    <ReviewBase
      deviceType={DESKTOP}
      templateCase={EXPRESS}
      showIncentives={false}
      showMlaTaxes={false}
      showTaxes={paymentMethod?.taxes?.length !== 0}
      showKycModal={showKycModal}
      customHandleKyc={handleKyc}
      customHandlePayClick={handlePayClick}
      customPrice={getCustomPrice()}
      customSummaryItems={getCustomSummaryItems()}
      customDiscountLegalTerms={getCustomDiscountLegalTerms()}
      isCombination={isCombination()}
      customFooterMessage={
        showBankInterests() && (
          <Message hierarchy="quiet" color="accent" className="review-express__bank_interests">
            {translations.BANK_INTERESTS}
          </Message>
        )
      }
      consumerCreditsFooter={
        showConsumerCreditsInfos && (
          <ConsumerCredits className="review-express__consumer-credits__footer">
            <ConsumerCredits.Legals siteId={siteId} />
          </ConsumerCredits>
        )
      }
      consumerCreditsSummary={
        showConsumerCreditsInfos && (
          <ConsumerCredits className="review-express__consumer-credits__summary">
            <ConsumerCredits.NextDueDate date={nextDueDate} siteId={siteId} />
            <ConsumerCredits.TermsAndConditions
              siteId={siteId}
              deviceType={DESKTOP}
              contractUrl={express?.installments?.[paymentMethod.option_id]?.contract}
            />
          </ConsumerCredits>
        )
      }
      customCardList={
        <PaymentMethodCardList
          withDividers
          deviceType={DESKTOP}
          items={paymentCardList}
          currentSelected={paymentMethod?.option_id}
          onChange={(value) => handlePaymentMethodChange(value)}
          bottomContentList={
            <CardFooter
              className={getBottomContentListClass()}
              link={{
                icon: true,
                text: translations.CHANGE_PAYMENT_METHOD,
                onClick: handleChangePaymentMethod,
              }}
            />
          }
        />
      }
      {...props}
    />
  );
};

ReviewExpress.defaultProps = {
  ...genericDefaultValues,
  step_model: {
    ...newInterfaceGenericDefaultValues,
  },
  rebrandingMP: false,
  isWebview: false,
};

ReviewExpress.propTypes = {
  ...genericPropsTypes,
  templateCase: PropTypes.string,
  step_model: PropTypes.shape({
    ...newInterfaceGenericPropsTypes,
  }).isRequired,
  rebrandingMP: PropTypes.bool,
  isWebview: PropTypes.bool,
  withCombination: PropTypes.bool,
};

// Map all the actions with the dispatchers on the props
const mapDispatchToProps = (dispatch) => ({
  stepActions: bindActionCreators(STEP_ACTIONS, dispatch),
  loadingActions: bindActionCreators(LOADING_ACTIONS, dispatch),
  requestActions: bindActionCreators(REQUEST_ACTIONS, dispatch),
  expressActions: bindActionCreators(EXPRESS_ACTIONS, dispatch),
  captchaToken: bindActionCreators(captchaToken, dispatch),
});

// Generate the state (store) using the reducers
const mapStateToProps = (state) => ({
  flow: state.page.flow,
  sdk: state.mercadopagoSdk,
  firstRender: state.page.firstRender,
  basePath: state.configurations.basePath,
  siteId: state.configurations.platform.siteId,
  captchaConfig: state.configurations.captcha,
  express: state.express,
  currency: state.configurations.currency,
  rebrandingMP: state.configurations.rebrandingMP,
  isWebview: state.configurations.isWebview,
  siteSecurity: state.configurations.siteSecurity,
});

module.exports = connectToReduxAndInjectI18n(
  withSmartTokenizationProvider(ReviewExpress),
  mapStateToProps,
  mapDispatchToProps,
);